import React from 'react'
import { loadStripe } from '@stripe/stripe-js'

const Bacs = ({ stripePriceId, buttonText }) => {
  const buyProduct = () => {
    return fetch('/.netlify/functions/stripe-createSession', {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: stripePriceId
      })
    })
      .then((res) => {
        return res.json()
      })
      .then(async (result) => {
        if (!result.sessionId) {
          throw new Error('There has been a Stripe Error')
        }
        const stripe = await loadStripe(process.env.GATSBY_STRIPE_PUBLISHABLE_KEY)
        stripe.redirectToCheckout({
          sessionId: result.sessionId
        })
      })
      .catch(function (e) {
        console.log(e)
        alert(e.message)
      })
  }
  return (
    <button
      className='block w-full mt-3 leading-6 rounded-lg rounded-bl-none border-2 border-white bg-gradient-to-tr from-fuchsia-800 via-indigo-800 to-teal-500 text-white hover:scale-105 transform transition duration-300 ease-in-out uppercase shadow px-6 py-3 text-base font-semibold '
      onClick={buyProduct}>
      {buttonText}
    </button>
  )
}

export default Bacs
